import { render, staticRenderFns } from "./PetStudentListDialog.vue?vue&type=template&id=d8b83d84&scoped=true"
import script from "./PetStudentListDialog.vue?vue&type=script&lang=js"
export * from "./PetStudentListDialog.vue?vue&type=script&lang=js"
import style0 from "./PetStudentListDialog.vue?vue&type=style&index=0&id=d8b83d84&prod&scoped=true&lang=css"
import style1 from "./PetStudentListDialog.vue?vue&type=style&index=1&id=d8b83d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b83d84",
  null
  
)

export default component.exports